import { User } from '../services/auth';

export const hasPermission = (user: User | null, permission: string): boolean => {
  if (user?.roles?.includes('owner')) {
    return true;
  }
  return user?.permissions?.includes(permission) ?? false;
};
